import React from 'react';
import LicensedModifiedSize from '../../../../getty/logicalComponents/LicensedModifiedSize/LicensedModifiedSize';
import MiniDownloadHistory from '../../MiniDownloadHistory/MiniDownloadHistory';

const ModifiedLicenseRedownloadForm = () => (
  <div data-testid="modified-license-redownload-form">
    <LicensedModifiedSize />
    <MiniDownloadHistory />
  </div>
);

export default ModifiedLicenseRedownloadForm;
